import React, { FC, useEffect } from 'react';

export interface TabItem {
    tabName: string | React.ReactNode;
    value: string;
    disabled?: boolean;
    disabledFn?: () => void | undefined;
}

interface Props {
    tabType?: 1 | 2 | 3;
    tabItems: Array<TabItem>;
    className?: string;
    selected?: string | null;
    onChange?: (val: string) => void;
    reset?: boolean;
}
/**
 *
 * @param tabType 탭 형태 / 디폴트 1
 * @param tabItems {value: 콘텐츠 id, tabName: 탭 버튼 명, disabled: 비활성 }
 * @param className 탭 추가 클래스
 * @param selected 선택된 아이템 id
 * @param onChange 체인지 콜백
 * @returns TabMenu
 */
export const TabMenu: FC<Props> = (props) => {
    const { tabType = 1, tabItems, className, selected, onChange, reset = false } = props;
    const [selectTab, setSelectTab] = React.useState<string>(selected ? selected : '');
    const handleButtonClick = (value: string) => {
        if (value !== selectTab) {
            setSelectTab(value);
            if (onChange) onChange(value);
        }
    };

    useEffect(() => {
        if (reset) {
            setSelectTab(selected ? selected : '');
        }
    }, [selected]);

    return (
        <div className={`tab-menu tab-type${tabType} ${className || ''}`}>
            <ul className="tab-list">
                {tabItems.map((item: any, idx: number) => {
                    return (
                        <li
                            className={`tab-item${item.value == selectTab ? ' isCurrent' : ''}`}
                            key={idx}
                        >
                            <button
                                type="button"
                                disabled={item.disabled}
                                onClick={() => {
                                    if (item.disabledFn) item.disabledFn();
                                    else handleButtonClick(item.value);
                                }}
                                className="tab-btn"
                            >
                                {item.tabName}
                            </button>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};
